<template>
  <div>
    <b-card v-if="isJdm" class="mb-2">
      <b-row class="mb-1">
        <b-col>
          <p>
            <small>{{ trans('jdm_you_have_access') }}</small>
          </p>
        </b-col>
      </b-row>
      <p v-if="jdm && jdm.allowed_sports.length > 0" class="mb-1">
        <small>
          {{ trans('jdm_you_have_access_sports') }}
          {{ jdm.allowed_sports.join(', ') }}
        </small>
      </p>
      <p v-if="jdm && jdm.allowed_boroughs.length > 0" class="mb-1">
        <small>
          {{ trans('jdm_you_have_access_boroughs') }}
          {{ jdm.allowed_boroughs.join(', ') }}
        </small>
      </p>
      <p>
        <small><em>{{ trans('jdm_access_instructions') }}</em></small>
      </p>
      <b-row>
        <b-col>
          <b-form-group :label="trans('show')">
            <b-form-radio-group
              v-model="jdm_show"
              :options="jdm_show_options"
              size="sm"
              :disabled="busy"
              @change="currentPage = 1"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col v-if="jdm_show == 'registrations'">
          <b-form-group :label="trans('search')">
            <b-input
              type="search"
              v-model="jdm_search"
              :placeholder="trans('child')"
              size="sm"
              :disabled="busy"
            />
          </b-form-group>
        </b-col>
        <b-col v-if="jdm_show == 'registrations' && jdmBoroughs && jdmBoroughs.length > 0">
          <b-form-group :label="trans('borough')">
            <b-form-select
              v-model="jdm_borough"
              :options="jdmBoroughOptions"
              size="sm"
              :disabled="busy"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="jdm_show == 'registrations' && jdmSports && jdmSports.length > 0">
          <b-form-group :label="trans('sport')">
            <b-form-select
              v-model="jdm_sport"
              :options="jdmSportOptions"
              size="sm"
              :disabled="busy"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="jdm_show == 'registrations' && jdmCategories && jdmCategories.length > 0">
          <b-form-group :label="trans('category')">
            <b-form-select
              v-model="jdm_category"
              :options="jdmCategoryOptions"
              size="sm"
              :disabled="busy"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="jdm_show == 'registrations' && jdmParticipantTypes && jdmParticipantTypes.length > 0">
          <b-form-group :label="trans('participant_type')">
            <b-form-select
              v-model="jdm_participant_type"
              :options="jdmParticipantTypeOptions"
              size="sm"
              :disabled="busy"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <strong v-if="jdm_show == 'registrations' && !!jdm_sport || jdm_show == 'accompagnateurs'" class="p-1 mb-2">
            {{ jdm_show == 'registrations' ? jdm_sport : trans('accompagnateurs') }}:
          </strong>
          <b-dropdown v-if="!!availableForms && availableForms.length > 0" variant="outline-branded" size="sm" class="mr-2 mb-2" menu-class="constrained" :disabled="busy">
            <template #button-content>
              <i class="fa fa-fw fa-plus"></i>
              {{ trans('registration') }}
            </template>
            <b-dropdown-item v-for="f in availableForms" :key="'rf'+f.id" @click="onClickAddRegistration(f)">
              {{ f.name }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown v-if="!!availableFormsForImport && availableFormsForImport.length > 0" variant="outline-branded" size="sm" class="mr-2 mb-2" menu-class="constrained" :disabled="busy">
            <template #button-content>
              <i class="fa fa-fw fa-upload"></i>
              {{ trans('import') }}
            </template>
            <b-dropdown-item v-for="f in availableFormsForImport" :key="'rf'+f.id" @click="onClickImportRegistrations(f)">
              {{ f.name }}
            </b-dropdown-item>
          </b-dropdown>
          <b-button v-if="!!excelUrl" variant="outline-branded" size="sm" class="mr-2 mb-2" :href="excelUrl" target="_blank" :disabled="busy">
            <i class="fa fa-fw fa-file-excel"></i>
            {{ trans('download_excel') }}
          </b-button>
          <b-button v-if="jdm_show == 'registrations'" variant="outline-branded" size="sm" class="mb-2 mr-2" v-b-modal.jdm-consent-modal :disabled="busy">
            <i class="fa fa-fw fa-file-signature"></i>
            {{ trans('consent') }}
          </b-button>

          <b-dropdown variant="outline-branded" size="sm" class="mr-2 mb-2" :disabled="busy">
            <template #button-content>
              <span :class="!filterType ? 'text-muted' : 'text-branded'">
                <i class="fa fa-fw fa-filter"></i>
                {{ filterLabel }}
              </span>
            </template>
            <b-dropdown-item @click="onChangeFilterType()">
              <i :class="`fa fa-fw ${!filterType ? 'fa-check' : ''}`"></i>
              {{ trans('all') }}
            </b-dropdown-item>
            <b-dropdown-item @click="onChangeFilterType('duplicates')">
              <i :class="`fa fa-fw ${filterType == 'duplicates' ? 'fa-check' : ''}`"></i>
              {{ trans('duplicates') }}
            </b-dropdown-item>
        </b-dropdown>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body>
      <b-table
        id="filled_forms"
        ref="table"
        class="bg-white"
        responsive
        show-empty
        :per-page="perPage"
        :current-page="currentPage"
        :fields="fields"
        :items="filteredItems"
        :sort-compare="sortByObjectNameAttr"
      >
        <template #empty>
          <p align="center">
            <span v-if="!busy">{{ trans('none') }}</span>
            <span v-if="busy">
              <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
              {{ trans('please_wait') }}
            </span>
          </p>
        </template>
        <template #head(recipient_form_name)="data">
          {{ data.label }}
          <b-button variant="link" size="sm" class="p-0 ml-1" @click="fetch" :disabled="busy">
              <i :class="`fa fa-fw ${busy ? 'fa-circle-notch fa-spin' : 'fa-redo'}`"></i>
          </b-button>
        </template>
        <template #cell(recipient_form_name)="data">
          {{ data.value }}
          <small class="d-block">
            <b-button
              v-if="isJdm && canModifyOrDelete(data.item)"
              variant="link"
              size="sm"
              class="p-0 mr-2"
              @click="onViewModify($event, data.item)"
              :title="trans('modify')"
              :disabled="busy"
            >
              <i class="fa fa-fw fa-edit"></i>
            </b-button>
            <b-button
              v-if="isJdm && canModifyOrDelete(data.item)"
              variant="link"
              size="sm"
              class="p-0 mr-2 text-danger"
              @click="onClickDelete($event, data.item)"
              :title="trans('deleted')"
              :disabled="busy"
            >
              <i class="fa fa-fw fa-times"></i>
            </b-button>
            <b-link :href="`/org/${organization.id}/client/filled_form_pdf/${data.item.id}`" target="_blank" :title="trans('download_pdf')">
              <i class="fa fa-fw fa-file-pdf"></i>
            </b-link>
            <span
              v-if="isJdm && !canModifyOrDelete(data.item)"
              :title="trans('registrations_are_closed_for_coaches')"
              v-b-tooltip.hover
              class="text-muted ml-2"
            >
              <i class="fa fa-fw fa-minus-circle"></i>
            </span>
          </small>
        </template>
        <template #cell(name)="data">
          <small class="d-block">
            {{ compact([
              data.value,
              data.item.email,
              data.item.mobile,
            ]).join(', ') }}
          </small>
        </template>
        <template #cell(children)="data">
          <small class="d-block" v-for="(child, index) in data.value" :key="index">
            {{
              compact([
                child.name,
                child.gender ? trans('gender_'+child.gender) : null,
                child.date_of_birth ? `${child.date_of_birth} (${moment().diff(child.date_of_birth, 'years')})` : null,
                child.grade ? `${trans('grade')} ${child.grade}` : null,
                child.email,
                child.mobile
              ]).join(', ')
            }}
          </small>
        </template>
        <template #cell(participant)="data">
          <small>
            {{
              compact([
                data.value.name,
                data.value.gender ? trans('gender_'+data.value.gender) : null,
                data.value.date_of_birth ? `${data.value.date_of_birth} (${moment().diff(data.value.date_of_birth, 'years')})` : null,
              ]).join(', ')
            }}
          </small>
        </template>
        <template #cell(media_answers)="data">
          <div v-for="answer in data.value" :key="answer.id" class="mb-2">
            <small class="d-block text-muted">{{ answer.label }}</small>
            <div v-for="media in answer.json" :key="media.umid">
              <b-button v-if="answer.type == 'images'" :href="mediaUrl(answer, media.umid)" target="_blank" variant="link" size="sm" class="p-0 text-left">
                <i class="fa fa-fw fa-image"></i> {{ media.name }}
              </b-button>
              <b-button v-if="answer.type == 'videos' && !media.deleted_at" @click="onClickVideo(answer, media)" variant="link" size="sm" class="p-0 text-left">
                <i class="fa fa-fw fa-video"></i> {{ media.name }}
              </b-button>
            </div>
          </div>
        </template>
        <template #cell(borough)="data">
          <small class="d-block">{{ data.value }}</small>
        </template>
        <template #cell(sport)="data">
          <small class="d-block">{{ data.value }}</small>
        </template>
        <template #cell(filled_at)="data">
          <small class="d-block">{{ data.value }}</small>
        </template>
      </b-table>
      <b-pagination
        :total-rows="filteredItems.length"
        :per-page="perPage"
        v-model="currentPage"
        aria-controls="filled_forms"
        align="center"
      ></b-pagination>
    </b-card>
    <jdm-consent-modal
      :organization="organization"
      :consent-form="jdm.consent_form"
    ></jdm-consent-modal>
    <client-form-iframe-modal
      :organization="organization"
      :upid="!!item ? item.recipient_form_upid : (!!recipient_form ? recipient_form.upid : null)"
      :urid="!!item ? item.urid || null : null"
      :title="trans(!!item ? 'modify' : 'add')"
      @hidden="fetch"
    ></client-form-iframe-modal>
    <form-import-modal
      :organization="organization"
      :recipient_form="recipient_form"
      :client="client"
      :client-tab="{id: 'jdm'}"
      show-jdm-consent
      @imported="fetch"
    ></form-import-modal>
    <b-modal
      id="filled-forms-video-modal"
      :title="media ? media.name : null"
      ok-only
      :ok-title="trans('close')"
      size="lg"
    >
      <div v-if="!!media">
        <video
          :src="media.url"
          controls
          class="w-100"
        />
      </div>
      <div v-if="!!media">
        <b-button variant="link" size="sm" class="text-muted" @click="video_only_audio = !video_only_audio">
          <i class="fa fa-fw fa-info-circle"></i>
          {{ trans('video_only_audio') }}
        </b-button>
        <b-alert variant="danger" :show="video_only_audio" class="mx-2">
          {{ trans('video_only_audio_note') }}
        </b-alert>
        <b-img v-if="video_only_audio" :src="downloadVideoInstructionsImageUrl" fluid />
      </div>
      <div v-if="!media">
        <p class="lead text-center my-4">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import ClientFormIframeModal from './ClientFormIframeModal'
  import FormImportModal from './../form/FormImportModal'
  import JdmConsentModal from './JdmConsentModal'

  function hasThing(value, things) {
    if (!value) return false
    value = value.toLowerCase()
    return _.reduce(things, (has, thing) => {
      if (value.indexOf(thing.toLowerCase()) >= 0) has = true
      return has
    }, false)
  }

  export default {
    props: {
      organization: Object,
      client: Object,
      jdm: Object,
    },
    components: {
      ClientFormIframeModal,
      FormImportModal,
      JdmConsentModal,
    },
    data() {
      return {
        trans: trans,
        compact: _.compact,
        moment: moment,
        busy: false,
        error: null,
        items: null,
        item: null,
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        jdm_borough: null,
        jdm_sport: null,
        jdm_participant_type: null,
        jdm_category: null,
        jdm_search: null,
        jdm_show: 'registrations',
        jdm_show_options: [
          {value: 'registrations', text: trans('registrations')},
          {value: 'accompagnateurs', text: trans('accompagnateurs')},
          {value: 'others', text: trans('others')},
        ],
        media: null,
        video_only_audio: false,
        recipient_form: null,
        filterType: null,
      }
    },
    computed: {
      availableForms() {
        if (this.jdm_show == 'registrations') {
          if (!this.jdm_sport) return this.jdm.registration_forms
          return _.compact([_.find(this.jdm.registration_forms, {sport: this.jdm_sport})])
        }
        if (this.jdm_show == 'accompagnateurs') {
          return _.compact([this.jdm.guide_registration_form])
        }
        return []
      },
      availableFormsForImport() {
        return _.reduce(this.availableForms, (forms, f) => {
          if (f.allow_import) forms.push(f)
          return forms
        }, [])
      },
      excelUrl() {
        if (this.jdm_show == 'others') return null
        let url = `/org/${this.organization.id}/client/excel`
        let parts = []
        if (this.jdm_show == 'accompagnateurs') {
          parts.push('only_accompagnateurs=true')
        } else {
          if (this.jdm_show == 'registrations') parts.push('only_registrations=true')
          if (this.jdm_borough) parts.push('borough=' + encodeURIComponent(this.jdm_borough))
          if (this.jdm_sport) parts.push('sport=' + encodeURIComponent(this.jdm_sport))
          if (this.jdm_participant_type) parts.push('participant_type=' + encodeURIComponent(this.jdm_participant_type))
          if (this.jdm_category) parts.push('category=' + encodeURIComponent(this.jdm_category))
          if (this.jdm_search) parts.push('search=' + encodeURIComponent(this.jdm_search))
        }
        let query = parts.join('&')
        if (query) url += '?' + query
        return url
      },
      isJdm() {
        return !!this.jdm
      },
      hasDifferentRespondent() {
        return _.reduce(this.items || [], (has, item) => {
          if (this.client.emails.indexOf(item.email) === -1) has = true
          return has
        }, false)
      },
      hasChildren() {
        return _.reduce(this.items || [], (has, item) => {
          if (item.children && item.children.length > 0) has = true
          return has
        }, false)
      },
      hasParticipant() {
        return _.reduce(this.items || [], (has, item) => {
          if (!!item.participant) has = true
          return has
        }, false)
      },
      hasMedia() {
        return _.reduce(this.items || [], (has, item) => {
          if (item.media_answers && item.media_answers.length > 0) has = true
          return has
        }, false)
      },
      fields() {
        return _.compact([
          {
            key: 'recipient_form_name',
            label: trans('form'),
          },
          this.hasDifferentRespondent ? {key: 'name', label: trans('respondent')} : null,
          this.hasChildren ? {key: 'children', label: trans('children')} : null,
          this.hasParticipant ? {key: 'participant', label: trans('participant'), sortable: true} : null,
          this.hasMedia ? {key: 'media_answers', label: trans('media')} : null,
          this.isJdm ? {key: 'borough', label: trans('borough'), sortable: true} : null,
          this.isJdm ? {key: 'sport', label: trans('sport'), sortable: true} : null,
          this.isJdm && this.jdm_show == 'registrations' ? {key: 'category', label: trans('category'), sortable: true} : null,
          this.isJdm && this.jdm_show == 'registrations' ? {key: 'participant_type', label: trans('participant_type'), sortable: true} : null,
          {
            key: 'filled_at',
            label: trans('date'),
            formatter(value, key, item) {
              return value ? moment(value).format('LLL') : null
            },
            sortable: true,
          },
          this.isJdm && this.jdm_show == 'registrations' ? {
            key: 'consented_at',
            label: trans('consent'),
            formatter(value, key, item) {
              return value ? moment(value).format('LLL') : null
            },
            sortable: true,
          } : null,
          this.isJdm && this.jdm_show == 'registrations' ? {
            key: 'photo',
            label: trans('photo'),
            sortable: true,
          } : null,
        ])
      },
      jdmBoroughs() {
        return _.reduce(this.items || [], (boroughs, item) => {
          if (item.borough && boroughs.indexOf(item.borough) === -1) boroughs.push(item.borough)
          return boroughs
        }, [])
      },
      jdmBoroughOptions() {
        return _.union([{value: null, text: trans('any')}], this.jdmBoroughs)
      },
      jdmSports() {
        return _.reduce(this.items || [], (sports, item) => {
          if (item.sport && sports.indexOf(item.sport) === -1) sports.push(item.sport)
          return sports
        }, [])
      },
      jdmSportOptions() {
        return _.union([{value: null, text: trans('any')}], this.jdmSports)
      },
      jdmParticipantTypes() {
        return _.reduce(this.items || [], (participant_types, item) => {
          if (item.participant_type && participant_types.indexOf(item.participant_type) === -1) participant_types.push(item.participant_type)
          return participant_types
        }, [])
      },
      jdmParticipantTypeOptions() {
        return _.union([{value: null, text: trans('any')}], this.jdmParticipantTypes)
      },
      jdmCategories() {
        return _.reduce(this.items || [], (categories, item) => {
          if (item.category && categories.indexOf(item.category) === -1) categories.push(item.category)
          return categories
        }, [])
      },
      jdmCategoryOptions() {
        return _.union([{value: null, text: trans('any')}], this.jdmCategories)
      },
      filteredItems() {
        return _.reduce(this.items || [], (items, item, index, allItems) => {
          let pass = true
          if (this.isJdm) {
            pass = false
            let is_registration = hasThing(item.recipient_form_name, this.jdmSports)
            let is_accompanying = (item.recipient_form_name||'').indexOf('Accompagnateur') >= 0
            if (this.jdm_show == 'registrations' && is_registration ||
              this.jdm_show == 'others' && !is_registration && !is_accompanying ||
              this.jdm_show == 'accompagnateurs' && is_accompanying)
              pass = true
            if (is_registration && pass) {
              if (pass && this.jdm_search) {
                let term = this.jdm_search.toLowerCase().trim()
                pass = (item.participant && item.participant.name ?
                    (item.participant.name && item.participant.name.toLowerCase().indexOf(term) >= 0) :
                    false) ||
                  _.reduce(item.children || [], (found, child) => {
                    if (child.name && child.name.toLowerCase().indexOf(term) >= 0) found = true
                    return found
                  }, false)
              }
              if (pass && this.jdm_borough) pass = this.jdm_borough == item.borough
              if (pass && this.jdm_sport) pass = this.jdm_sport == item.sport
              if (pass && this.jdm_category) pass = this.jdm_category == item.category
              if (pass && this.jdm_participant_type) pass = this.jdm_participant_type == item.participant_type
              if (this.filterType && this.filterType == 'duplicates') {
                let nameCount = _.countBy(allItems, (i) => i.participant?.name)
                pass = pass && nameCount[item.participant?.name] > 1
              }
            }
          }
          if (pass) items.push(item)
          
          return items
        }, [])
      },
      downloadVideoInstructionsImageUrl() {
        return `https://activitymessenger-assets-ca.s3.ca-central-1.amazonaws.com/help/video-not-playing-${window.lang}.png`
      },
      filterLabel() {
        if (!this.filterType) return this.trans('filter')
        return trans(this.filterType)
      },
    },
    methods: {
      onClickAddRegistration(recipient_form) {
        this.item = null
        this.recipient_form = recipient_form
        this.$bvModal.show('client-form-iframe-modal')
      },
      onClickImportRegistrations(recipient_form) {
        this.item = null
        this.recipient_form = recipient_form
        this.$bvModal.show('form-import-modal')
      },
      canModifyOrDelete(item) {
        let sport = item.sport
        return this.jdm.allowed_boroughs.length > 0 ||
          this.jdm.lock_sports_for_coaches.indexOf(sport) === -1 ||
          this.jdm.allowed_sports.indexOf(sport) !== -1
      },
      onClickVideo(answer, media) {
        this.media = _.assign({}, media, {url: this.mediaUrl(answer, media.umid)})
        this.$bvModal.show('filled-forms-video-modal')
      },
      mediaUrl(answer, umid) {
        return `/org/${this.organization.id}/client/answer/${answer.id}/media/${umid}`
      },
      onClickDelete(e, item) {
        e.preventDefault()
        let message = trans('delete_confirm')
        if (this.hasClass) message = trans('delete_confirm')
        this.$bvModal.msgBoxConfirm(message, {
          title: item.participant ? item.participant.name : '',
          okTitle: trans('delete'),
          okVariant: 'danger',
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) return
          const url = `/org/${this.organization.id}/client/filled_forms/${item.recipient_id}`
          axios.delete(url)
          .then(response => {
            this.$bvToast.toast(response.data.message, {
              title: trans('success'),
              variant: 'success',
              solid: true,
            })
            this.fetch()
          })
          .catch(error => {
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        })
      },
      onViewModify(e, item) {
        e.preventDefault()
        this.recipient_form = null
        this.item = item

        if (this.item.urid) {
          this.$bvModal.show('client-form-iframe-modal')
          return
        }

        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/urid_for_recipient/${this.item.recipient_id}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.item.urid = response.data.urid
          this.$bvModal.show('client-form-iframe-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
        })
      },
      fetch() {
        this.busy = true
        this.error = null
        this.items = null
        let query = `?page=${this.currentPage}&per_page=${this.perPage}`
        let url = `/org/${this.organization.id}/client/filled_forms${query}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.items = response.data
          this.totalRows = this.items.length
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.items = []
        })
      },
      onChangeFilterType(type) {
        if (type === 'all') this.filterType = null
        else this.filterType = type
      },
      sortByObjectNameAttr(a, b, key, sortDesc) {
        if (key === 'participant') {
          const nameA = a[key]?.name || '';
          const nameB = b[key]?.name || '';

          return nameA < nameB ? -1 : nameA > nameB ? 1 : 0
        }
      
        return null
      }
    },
    mounted() {
      window.myFilledForms = this
      this.fetch()
    },
  }
</script>